import { TypographyOptions } from '@material-ui/core/styles/createTypography';

const fontName = 'Roboto';
const htmlFontSize = 14;

export function pxToRem(pxFontSize: number): string {
  return `${pxFontSize / htmlFontSize}rem`;
}

export function getLineHeight(
  pxLineHeight: number,
  pxFontSize: number
): number {
  return pxLineHeight / pxFontSize;
}

const typography: TypographyOptions = {
  htmlFontSize,
  fontFamily: `"${fontName}", Tahoma, Helvetica, Arial, sans-serif`,
  body1: {
    fontSize: pxToRem(14),
    fontWeight: 400,
  },
  body2: {
    fontSize: pxToRem(14),
    fontWeight: 700,
  },
  h1: {
    fontSize: pxToRem(36),
    fontWeight: 700,
  },
  h2: {
    fontSize: pxToRem(24),
    fontWeight: 500,
  },
  h3: {
    fontSize: pxToRem(17),
    fontWeight: 500,
  },
  overline: {
    fontSize: pxToRem(12),
    letterSpacing: '2px',
    fontWeight: 500,
  },
  button: {
    fontSize: pxToRem(14),
    fontWeight: 400,
  },
  caption: {
    fontSize: pxToRem(12),
    fontWeight: 400,
  },
};

export default typography;
